module.exports = __webpack_public_path__ + "static/square-bluesky-brands-solid-abd631dbc3c991df46d684b89c1bd79d.png";